import { gateway } from "../../../gateway";

export type GetOnePasswordResponse =
  | { requires2FA: true; message: string; id: string }
  | { id: string; title: string; usernameEmail: string; password: string; highSecurity: boolean; };

export async function fetchPasswordVaultStatus(id: string | number, code?: string) {
  const token = sessionStorage.getItem("token");

  const res = await gateway.get(`/passwords/${id}`, {
    headers: { Authorization: token ? `Bearer ${token}` : "" },
    params: code ? { code } : undefined,
  });

  // backend returns { status, ...result } for 202, and { status, data: result } for 200
  return (res.data?.data ?? res.data) as GetOnePasswordResponse;
}

